import React, { useMemo } from 'react';
import { PRODUCTS, CATEGORIES, formatPrice } from '../data/products';
import ProductGrid from '../components/ProductGrid';
import Banner from '../components/Banner';

// Encabezados descriptivos por categoría
const CATEGORY_HEADERS = {
  mascotas: {
    title: 'Para tus mascotas',
    subtitle: 'Todo lo que necesitan tus compañeros peludos — desde camas hasta juguetes y accesorios.',
    color: 'linear-gradient(135deg, #1a5c2e 0%, #2d7a42 100%)',
    emoji: '🐾',
  },
  hogar: {
    title: 'Para tu hogar',
    subtitle: 'Organización, decoración y confort. Transforma cada rincón de tu casa.',
    color: 'linear-gradient(135deg, #1a4f7a 0%, #2d6fa4 100%)',
    emoji: '🏠',
  },
  limpieza: {
    title: 'Limpieza y orden',
    subtitle: 'Productos de limpieza eficientes y ecológicos para mantener tu hogar impecable.',
    color: 'linear-gradient(135deg, #2d7a5c 0%, #42a680 100%)',
    emoji: '🧹',
  },
  tecnologia: {
    title: 'Tecnología',
    subtitle: 'Gadgets y accesorios tech que hacen tu vida más fácil y conectada.',
    color: 'linear-gradient(135deg, #2a2a5c 0%, #4a4aaa 100%)',
    emoji: '💻',
  },
  ofertas: {
    title: 'Ofertas especiales',
    subtitle: 'Los mejores precios del momento. ¡Aprovecha antes que se acaben!',
    color: 'linear-gradient(135deg, #7a3a1a 0%, #e8860a 100%)',
    emoji: '🏷️',
  },
};

export default function CategoryPage({ category, onProductClick, searchQuery }) {
  const header = CATEGORY_HEADERS[category] || {};
  const catInfo = CATEGORIES.find(c => c.id === category) || {};

  const allCatProducts = useMemo(() =>
    PRODUCTS.filter(p => p.category === category),
    [category]
  );

  const realProducts = useMemo(() => {
    let result = allCatProducts.filter(p => !p.isPlaceholder);
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(p =>
        p.name.toLowerCase().includes(q) ||
        (p.description && p.description.toLowerCase().includes(q))
      );
    }
    return result;
  }, [allCatProducts, searchQuery]);

  const placeholders = useMemo(() =>
    allCatProducts.filter(p => p.isPlaceholder),
    [allCatProducts]
  );

  const showingAll = !searchQuery.trim();

  return (
    <>
      {/* Hero de categoría */}
      <section style={{
        background: header.color,
        color: 'white',
        padding: '48px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Círculos decorativos */}
        <div style={{
          position: 'absolute', top: '-60px', right: '-60px',
          width: '220px', height: '220px', borderRadius: '50%',
          background: 'rgba(255,255,255,0.06)',
        }} />
        <div style={{
          position: 'absolute', bottom: '-40px', left: '15%',
          width: '160px', height: '160px', borderRadius: '50%',
          background: 'rgba(255,255,255,0.04)',
        }} />

        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255,255,255,0.25)', borderRadius: '50px',
            padding: '6px 16px', fontSize: '13px', fontWeight: 700,
            marginBottom: '16px', color: 'rgba(255,255,255,0.95)',
          }}>
            ShuCore.online
          </div>

          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            fontWeight: 800,
            marginBottom: '12px',
            lineHeight: 1.2,
          }}>
            {header.emoji} {header.title}
          </h1>

          <p style={{ fontSize: '16px', opacity: 0.88, maxWidth: '560px', lineHeight: 1.6 }}>
            {header.subtitle}
          </p>

          <div style={{
            marginTop: '24px',
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: 'rgba(255,255,255,0.2)', borderRadius: '50px',
            padding: '8px 18px', fontSize: '14px', fontWeight: 700,
          }}>
            {realProducts.length} producto{realProducts.length !== 1 ? 's' : ''} disponible{realProducts.length !== 1 ? 's' : ''}
          </div>
        </div>
      </section>

      {/* Grid de productos */}
      <section id="productos" style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 20px' }}>
        {realProducts.length === 0 && searchQuery.trim() ? (
          <div style={{ textAlign: 'center', padding: '80px 20px', color: 'var(--gray-400)' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
            <h3 style={{ fontWeight: 700, marginBottom: '8px' }}>Sin resultados</h3>
            <p>Intenta con otra búsqueda</p>
          </div>
        ) : (
          <ProductGrid
            products={realProducts}
            placeholders={showingAll ? placeholders : []}
            
            onProductClick={onProductClick}
            showPlaceholders={showingAll}
          />
        )}
      </section>

      <Banner />
    </>
  );
}
